var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.448,
    height: 59.349,
    viewBox: "0 0 53.448 59.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rt_",
    "data-name": "rt ",
    transform: "translate(0.113 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M191.144,26.147l-9.858-9.858a.986.986,0,0,0-.7-.289H155.943A3.948,3.948,0,0,0,152,19.943V48.532h1.972V19.943a1.974,1.974,0,0,1,1.972-1.972H179.6v5.915a3.948,3.948,0,0,0,3.943,3.943h5.915V71.206a1.974,1.974,0,0,1-1.972,1.972H155.943a1.967,1.967,0,0,1-1.314-.5l-1.315,1.469a3.937,3.937,0,0,0,2.629,1h31.546a3.948,3.948,0,0,0,3.943-3.943V26.844a.986.986,0,0,0-.289-.7Zm-9.569-2.26V19.366l6.492,6.492h-4.521A1.974,1.974,0,0,1,181.574,23.887Z",
    transform: "translate(-138.198 -16)",
    fill: "#ff007f",
    stroke: "#ff007f",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M184,128h6.9v1.972H184Z",
    transform: "translate(-166.254 -118.265)",
    fill: "#ff007f",
    stroke: "#ff007f",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M184,128h6.9v1.972H184Z",
    transform: "translate(-166.254 -108.9)",
    fill: "#ff007f",
    stroke: "#ff007f",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M256,128h7.887v1.972H256Z",
    transform: "translate(-229.382 -118.265)",
    fill: "#ff007f",
    stroke: "#ff007f",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M256,128h7.887v1.972H256Z",
    transform: "translate(-229.382 -108.9)",
    fill: "#ff007f",
    stroke: "#ff007f",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M184,160h8.872v1.972H184Z",
    transform: "translate(-166.254 -146.322)",
    fill: "#ff007f",
    stroke: "#ff007f",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M184,160h8.872v1.972H184Z",
    transform: "translate(-166.254 -136.957)",
    fill: "#ff007f",
    stroke: "#ff007f",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M224.986,408a.986.986,0,0,0-.986.986V414.9a.986.986,0,0,0,.986.986H230.9a.986.986,0,0,0,.986-.986v-5.915A.986.986,0,0,0,230.9,408Zm4.929,5.915h-3.943v-3.943h3.943Z",
    transform: "translate(-201.325 -359.695)",
    fill: "#ff007f",
    stroke: "#ff007f",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M304,379.83a.986.986,0,0,0,.986.986H310.9a.986.986,0,0,0,.986-.986V368.986A.986.986,0,0,0,310.9,368h-5.915a.986.986,0,0,0-.986.986Zm1.972-9.858h3.943v8.872h-3.943Z",
    transform: "translate(-271.467 -324.624)",
    fill: "#ff007f",
    stroke: "#ff007f",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M384.986,352.759H390.9a.986.986,0,0,0,.986-.986V336.986A.986.986,0,0,0,390.9,336h-5.915a.986.986,0,0,0-.986.986v14.787A.986.986,0,0,0,384.986,352.759Zm.986-14.787h3.943v12.816h-3.943Z",
    transform: "translate(-341.609 -296.567)",
    fill: "#ff007f",
    stroke: "#ff007f",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M41.966,287.855a8.883,8.883,0,0,1,8.453-8.862l-1.264,1.264,1.394,1.394,2.957-2.957a.986.986,0,0,0,0-1.394l-2.957-2.957-1.394,1.394,1.283,1.283a10.845,10.845,0,0,0-5.022,20.228l.987-1.707a8.907,8.907,0,0,1-4.437-7.686Z",
    transform: "translate(-39.993 -242.508)",
    fill: "#ff007f",
    stroke: "#ff007f",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M117.8,317.17a10.884,10.884,0,0,0-5.421-9.393l-.987,1.707a8.873,8.873,0,0,1-4.016,16.548l1.264-1.264-1.394-1.394-2.957,2.957a.986.986,0,0,0,0,1.394l2.957,2.957,1.394-1.394-1.283-1.283A10.857,10.857,0,0,0,117.8,317.17Z",
    transform: "translate(-96.112 -271.822)",
    fill: "#ff007f",
    stroke: "#ff007f",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M102.694,349.626a.986.986,0,0,0,.289-.7V344h-1.972v4.521l-2.669,2.669,1.394,1.394Z",
    transform: "translate(-91.152 -303.581)",
    fill: "#ff007f",
    stroke: "#ff007f",
    strokeWidth: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRt);
export default __webpack_public_path__ + "static/media/rt.41b7761bdb5134270841bc4d1b73b184.svg";
export { ForwardRef as ReactComponent };